module.exports = __webpack_public_path__ + "static/visibleLabelsNo-89e8587ae7c398bf9e72f46073ff737c.png";